import { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { getManagerPanel } from '../../services/migration/personnelDataService';
import {
  resolveStockCountPermissions,
  type StockCountUiPermissions,
} from '../accounting/inventory/stockCount/stockCountPermissions';

export type ManagerStockCountPermissions = StockCountUiPermissions & { loaded: boolean };

const NONE: ManagerStockCountPermissions = {
  canView: false, canCreate: false, canCount: false, canQuick: false, canApprove: false, loaded: false,
};

/** Şube yöneticisinin stok sayım yetkileri. `enabled` false ise istek atılmaz. */
export const useManagerStockCountPermissions = (enabled: boolean): ManagerStockCountPermissions => {
  const { currentUser } = useAuth();
  const [perms, setPerms] = useState<ManagerStockCountPermissions>(NONE);

  useEffect(() => {
    if (!enabled || !currentUser?.uid) {
      setPerms(NONE);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const mp = await getManagerPanel(currentUser.uid);
        if (cancelled) return;
        setPerms({ ...resolveStockCountPermissions(mp.found ? mp.settings : null), loaded: true });
      } catch (e) {
        console.warn('[useManagerStockCountPermissions] managerPanel okunamadı:', e);
        if (!cancelled) setPerms({ ...NONE, loaded: true });
      }
    })();
    return () => { cancelled = true; };
  }, [enabled, currentUser?.uid]);

  return perms;
};
